module.exports = __webpack_public_path__ + "img/hx_meiti.b0aefa10.png";